import app from './lib/pico-init'

app.mount()

//web components
import { AccordionItem } from './components/web-components/accordion-item'
import { AddButton } from './components/web-components/add-button'
import { BodyOverlay } from './components/web-components/body-overlay'
import { CartCount } from './components/web-components/cart-count'
import { CartDrawer } from './components/web-components/cart-drawer'
import { DropdownButton } from './components/web-components/dropdown-button'
import { FreeGiftProgressBar } from './components/web-components/free-gift-progress'
import { ProgressBar } from './components/web-components/progress-bar'
import { SideDrawer } from './components/web-components/side-drawer'
import { SideDrawerBtn } from './components/web-components/side-drawer-btn'
import { ToggleSwitch } from './components/web-components/toggle-switch'
import { MobileOverflowScroll } from './components/web-components/mobile-overflow-scroll'
import {ScarcityIndicator} from './components/web-components/scarcity-indicator' 

export {
  AccordionItem,
  AddButton,
  BodyOverlay,
  CartCount,
  CartDrawer,
  DropdownButton,
  FreeGiftProgressBar,
  ProgressBar,
  SideDrawer,
  SideDrawerBtn,
  ToggleSwitch,
  MobileOverflowScroll,
  ScarcityIndicator
}
